module.exports = "https://web-assets-production.autolist.com/_next/static/images/guides_image-6abb4f802515cffaac49f7d64b977817.png";